<script>
import { pricify } from '@utils/currency'

export default {
  props: {
    tipAmounts: {
      type: Array,
      default: () => [10, 12.5, 15],
    },
    total: {
      type: Number,
      default: 0,
    },
  },
  data: () => ({
    selected: null,
  }),
  methods: {
    calculateTip(amount) {
      return pricify(this.total * (amount / 100))
    },
    handleSelect(index, amount) {
      if (this.selected !== index) {
        this.selected = index
        this.$emit('select', this.calculateTip(amount))
      } else {
        this.selected = null
        this.$emit('select', null)
      }
    },
    handleClear() {
      this.selected = null
    },
  },
}
</script>

<template>
  <div :class="$style.container">
    <BaseButton
      v-for="(amount, index) in tipAmounts"
      :key="amount"
      :class="{
        [$style.button]: true,
        [$style.selected]: selected === index,
      }"
      @click="handleSelect(index, amount)"
    >
      <span>{{ amount }}%</span>
      <span>£{{ calculateTip(amount) }}</span>
    </BaseButton>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.container {
  align-items: flex-end;
  display: flex;
  justify-content: center;
  overflow: hidden;
  position: relative;
  text-align: center;
}

.button {
  align-items: center;
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  margin: 0 5px;
  min-width: auto;
  padding: 1.4rem 0.1rem;
  transition: all 0.3s ease-in-out;
  border: var(--color-primary) 1px solid;
  background-color: var(--color-secondary);
  color: white;

  &:first-child,
  &:last-child {
    margin: 0;
  }

  span {
    &:first-child {
      font-size: 18px;
      font-weight: bold;
      letter-spacing: 0.5px;
      margin-bottom: 4px;
    }

    &:last-child {
      font-size: 16px;
      font-weight: normal;
      letter-spacing: 0.3px;
    }
  }
}

.selected {
  background-color: var(--color-primary);
}
</style>
